<template>
    <div class="x-easy-upload">
        <el-upload
            ref="upload"
            v-model:file-list="localFiles"
            :drag="!readonly && !config?.readonly"
            :action="config.action"
            :headers="{'Authorization': 'Bearer ' + tokenStore.token}"
            :multiple="false"
            :on-success="uploadSuccessHandler"
            :on-exceed="exceedHandler"
            :limit="1"
        >
            <div v-if="!readonly && !config?.readonly">
                <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                <div class="el-upload__text">
                    <em>拖拽文件至此区域或点击上传</em>
                </div>
            </div>
            <template #tip>
                <div class="el-upload__tip">{{getUploadTip(config)}}</div>
            </template>
            <template #file="{ file }">
                <div style="poistion: relative;">
                    <div class="el-upload-list__item-progress" v-if="file.percentage < 100" :style="'width:' + file.percentage + '%;'"></div>
                    <div class="el-upload-list__item-info">
                        <a @click="()=> processDownloadFile(file)" class="el-upload-list__item-name">
                            <el-icon><Document/></el-icon>
                            <span class="el-upload-list__item-file-name">{{file.fileName || file.name}}</span>
                        </a>
                    </div>
                    <label class="el-upload-list__item-status-label">
                        <el-icon class="el-icon--upload-success"><CircleCheck/></el-icon>
                    </label>
                    <!-- <el-icon class="el-icon--close" v-if="!readonly" @click.stop="processRemoveFile(file)"><Close/></el-icon> -->
                </div>
            </template>
        </el-upload>
    </div>
</template>
<script setup>
import { getCurrentInstance, ref, watch } from 'vue';
import { UploadFilled, CircleCheck, Close, Document } from '@element-plus/icons-vue';
import { genFileId } from 'element-plus'
import axios from 'axios';
import { useTokenStore } from '../../store/TokenStore';
import { getSign } from '../../remoteservice/RemoteService';

const inst = getCurrentInstance();
const tokenStore = useTokenStore();

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
})

defineEmits({
    'update:modelValue': null,
    'update:data': null,
})

const getFileList = (data)=> {
    const file = Object.assign({}, data);
    file.uid = genFileId();
    file.name = file.fileName;
    return file ? [{name:file.fileName, size:file.size, percentage:100, data:file}] : [];
}

const localFiles = ref([]);
watch(()=>props.data, (value)=> {
    if (!value || !value.id)  return;
    localFiles.value = getFileList(value);
    inst.emit('update:data', value)
}, {immediate:true})

const getUploadTip = (config)=> {
    let tip = '';
    if (config.fileType) {

    }
    if (config.size) {
        tip += `（大小限制${(config.size)}MB）`
    }
    return tip;
}

const getContentType = (fileName)=> {
    let ext = fileName.replace(/.*\./, '');
    if (ext == fileName) ext = '';
    switch (ext) {
        default:
        case 'txt':
        case 'json': return 'text';
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'bmp':  return 'pic';
        case 'xls':
        case 'xlsx': return 'xls';
        case 'doc':
        case 'docx': return 'doc';
        case 'mp4': return 'video';
        case 'mp3':
        case 'wav': return 'audio';
        case 'flv': return 'animation';
        case 'obj': return '3d';
    }
}

const uploadSuccessHandler = (res, file)=> {
    console.log('upload success', res, file);
    // const fields = ['extensionName', 'resourceUri'];
    const data = {};
    // for (const field of fields) {
    //     data[field] = res.data[field];
    // }
    data[props.field] = res.data.resourceUri;
    file.data = Object.assign(props.data, file.data, data, {fileName:file.name, size:file.size, contentType:getContentType(file.name)});
    inst.emit('update:data', file.data);
}
const exceedHandler = (files) => {
    console.log(files)
    const upload = inst.refs.upload;
    // @ts-ignore
    upload.clearFiles();
    const file = files[0];
    file.uid = genFileId();
    // @ts-ignore
    upload.handleStart(file);
    // @ts-ignore
    upload.submit();
}

const processDownloadFile = (file)=> {
    console.log('file', file);
    const url = props.config.download + '/' + btoa(file.data.resourceUri);
    const sign = getSign(props.config.download);
    axios({
        method: "GET",
        url: url,
        // data: JSON.stringify({uri:file.data.resourceUri}),
        headers: {
            'Authorization': 'Bearer ' + tokenStore.token,
            "Content-Type": "application/json",
        },
        responseType: 'blob' //返回是个文件
    }).then(response => {
        var blob = new Blob([response.data])
        var downloadElement = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = file.name; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    })
}
</script>
<style scoped>
.x-easy-upload {
    width: 100%;
}
</style>